import { Refresh } from '@browser/Browser';
import { isNullOrWhitespace } from '@common/Common';
import { guid } from '@common/Guid';
import { ICommandBase } from '@Quest/cqrs';
import { CreateStrategyCommandV1 } from '@Quest/Strategies/Domain/commands-core';
import StrategiesCommands from '@Quest/Strategies/Domain/commands-vue-component';
import StrategiesQueries from '@Quest/Strategies/Domain/queries-vue-component';
import { StrategyReadModel } from '@Quest/Strategies/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';

@Component({ components: { }})
export default class StrategyLaunchPage extends mixins(StrategiesQueries, StrategiesCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }

    mounted()
    {
        document.title = "Strategy | TransparentChoice";
        this.runStrategyByWorkspaceIdQueryV1(this.workspaceId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "StrategyReadModel")
        {
            const rm = model as StrategyReadModel;

            if (!isNullOrWhitespace(rm.DashboardUrl))
            {
                window.location.href = rm.DashboardUrl;
            }
            else
            {
                this.invokeCreateStrategyCommandV1(this.workspaceId, guid(), "Strategy", "");
            }
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateStrategyCommandV1.matchType(cmd))
        {
            Refresh();
        }
    }
}